import connect from './connect'
import OrderListPage from './OrderListPage'

export default connect(OrderListPage)
